<template>
  <div class="d-flex flex-column align-center">
    <div class="d-flex align-center pt-5 pb-2">
      <div class="titre-h3 align-self-center secondary--text">
        Besoin d'aide ?
      </div>
    </div>
    <div
      :class="$vuetify.breakpoint.mobile ? '' : 'card-width'"
      class="d-flex align-center flex-column titre-h4 secondary--text px-3 pb-4"
    >
      <ContactConseiller code-feature="DETAILS_ABONNEMENT" />
    </div>
    <div
      v-if="hasDemandeRecente"
      class="d-flex justify-center intro secondary--text py-3"
    >
      <v-icon
        class="px-3"
        color="secondary"
      >
        mdi-check
      </v-icon>
      <div class="align-self-center">
        Un email a bien été envoyé
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ContactConseiller from '@/components/contact-conseiller.vue'

export default {
  name: 'AideAbonnement',
  components: {ContactConseiller},

  computed: {
    ...mapGetters({
      hasDemandeRecente: 'demandeInfosAbonnement/hasDemandeRecente',
    }),
  },
}
</script>

<style lang="scss" scoped>
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.card-width {
  width: 500px;
}
</style>
